/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import ClickableDiv from 'components/Common/ClickableDiv';
import HideableContainer from 'components/Common/HideableContainer';
import Steps from '../steps';
import Styles from './index.module.css';

export default function LoginNavButtons({ step, onChangeStep, ...props }) {
  const isNormalNavStep = [
    Steps.ForgotPassword,
    Steps.ResetPassword,
    Steps.ActivateAccount,
    Steps.Home,
  ].includes(step);
  const isFancyNavStep = [Steps.Introduction, Steps.Calculator, Steps.Questions].includes(step);
  const isNavStep = isNormalNavStep || isFancyNavStep;
  return (
    <div className={Styles.mainContainer} {...props}>
      <HideableContainer className={Styles.content} hidden={!isNavStep}>
        <ClickableDiv
          onClick={() => onChangeStep(Steps.Register)}
          className={Styles.link}
        >
          <span>{isFancyNavStep ? '立即' : ''}</span>
          <span>註冊</span>
        </ClickableDiv>
        <span className={Styles.divider}>/</span>
        <ClickableDiv
          onClick={() => onChangeStep(Steps.Login)}
          className={Styles.link}
        >
          登入
        </ClickableDiv>
      </HideableContainer>
    </div>
  );
}

LoginNavButtons.propTypes = {
  step: PropTypes.string,
  onChangeStep: () => {},
};

LoginNavButtons.defaultProps = {
  step: '',
  onChangeStep: () => {},
};
